import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateUser,
  withTextLocalizer,
  setPhoneNumber as setPhoneNumberRedux,
  LocalizePropType,
  selectPhoneCodes,
  processPhoneNumber,
  extractNationalNumber,
  validatePhoneNumber,
  selectBrandSettings,
} from 'getaway-data-layer';
import AddPhoneView from './AddPhoneView';
import {
  GA_TITLES,
  isDashboardScreen,
  navigateTo,
  reportGAEvent,
  showAlert,
} from '../../../../utils';
import { PhoneItem } from './types';

type Props = {
  localize: LocalizePropType;
};

const AddPhoneContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const brandSettings = useSelector(selectBrandSettings);

  const defaultCountry = brandSettings?.defaultCountryCode;
  const phoneCodes = useSelector(selectPhoneCodes);
  const [phoneNumber, setPhoneNumber] = useState<PhoneItem>({
    value: '',
    dialCode: null,
    error: '',
  });

  const oSuccess = () => {
    navigateTo(
      history,
      `/${isDashboardScreen() ? 'dashboard' : 'onboarding'}/verifyPhone`
    );
    reportGAEvent(GA_TITLES.ON_BOARDING.PHONE_SUBMITTED);
  };

  const onSubmit = () => {
    if (isValidNumber()) {
      dispatch(setPhoneNumberRedux(phoneNumber.value));
      dispatch(
        updateUser({ phoneNumber: phoneNumber.value.trim() }, oSuccess, () => {
          setTimeout(
            () =>
              navigateTo(
                history,
                '/forget-email?phoneNumber=' +
                  encodeURIComponent(phoneNumber.value.trim())
              ),
            100
          );
        })
      );
    }
  };

  const onPhoneNumberChanged = (value: string, data: any) => {
    const formattedPhoneNumber = processPhoneNumber(value, data);

    setPhoneNumber({
      dialCode: data?.dialCode,
      value: formattedPhoneNumber,
      error: '',
    });
  };

  const isValidNumber = () => {
    const nationalNumber = extractNationalNumber(
      phoneNumber.value,
      phoneNumber.dialCode || ''
    );
    const error = validatePhoneNumber(nationalNumber);

    setPhoneNumber({
      dialCode: phoneNumber.dialCode,
      value: phoneNumber.value,
      error,
    });
    return !error;
  };

  const onClose = () => {
    if (isDashboardScreen()) {
      navigateTo(history, '/settings');
    } else {
      showAlert(
        '',
        localize('cancel.FirstSteps.dialog.message'),
        localize('cancel.FirstSteps.dialog.yes'),
        () => navigateTo(history, '/settings'),
        localize('cancel.FirstSteps.dialog.no'),
        () => {},
        true
      );
    }
  };

  return (
    <AddPhoneView
      phoneNumber={phoneNumber}
      localize={localize}
      phoneCodes={phoneCodes}
      defaultCountry={defaultCountry}
      onClose={onClose}
      onSubmit={onSubmit}
      isValidNumber={isValidNumber}
      onPhoneNumberChanged={onPhoneNumberChanged}
    />
  );
};

export default withTextLocalizer(AddPhoneContainer);
